import React, { useCallback, useState } from 'react';

import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  CloseOutlined,
} from '@ant-design/icons';
import { Button, Input } from '@mm/components';
import { useCampaignCRUDActions } from '@mm/state/actions/CampaignsCRUDActions';
import { StoreState } from '@mm/state/store-interfaces';
import { useSelector } from 'react-redux';
import {
  activeChatbotIdSelector,
  activeFacebookPageIdSelector,
} from '@mm/state/selectors/viewSelectors';
import styles from './ImportAutomationModal.module.css';
import { CloseModalProps } from '../../../../../../../../common/modals/modal-helpers';
import { useCampaignsOverviewCRUDActions } from '@mm/state/actions/CampaignsOverviewCRUDActions';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { useLocation } from 'react-router-dom';
import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';
import { ExplainerButton } from '../ExplainerButton/ExplainerButton';
import classNames from 'classnames';

export const ImportAutomationModal = (props: CloseModalProps) => {
  const { closeModal } = props;
  const [token, setToken] = useState('');
  const [showExplainer, setShowExplainer] = useState(false);
  const botId = useSelector(activeChatbotIdSelector);
  const campaignsCRUDActions = useCampaignCRUDActions();
  const campaignsOverviewCRUDActions = useCampaignsOverviewCRUDActions();
  const facebookPageId = useSelector(activeFacebookPageIdSelector);
  const busy = useSelector((state: StoreState) => state.campaigns.busy);
  const { openCloneAutomationModal } = useModalActions();
  const location = useLocation();
  const activeBotId = useSelector(activeFacebookPageSelector)?.activeBotId;
  const pathBotId = Number(location.pathname.split('/')[2]);

  const handleSubmit = useCallback(async () => {
    try {
      openCloneAutomationModal({
        showCongratulation: true,
      });
      await campaignsCRUDActions.clone(
        token,
        activeBotId
          ? Array.from({ length: 1 }, x => facebookPageId)
          : undefined,
        !activeBotId ? Array.from({ length: 1 }, x => pathBotId) : undefined,
      );

      await campaignsOverviewCRUDActions.retrieveAll({
        botId,
        kind: 'automation',
        pagination: {
          page: 1,
          perPage: 8,
        },
      });
    } catch (err) {}
  }, [
    openCloneAutomationModal,
    campaignsCRUDActions,
    token,
    facebookPageId,
    botId,
    campaignsOverviewCRUDActions,
    activeBotId,
    pathBotId,
  ]);

  return (
    <div className={styles.container}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <span className={styles.back} onClick={closeModal}>
            <ArrowLeftOutlined />
          </span>
          My Automations
          <span className={styles.close} onClick={closeModal}>
            <CloseOutlined />
          </span>
        </div>
        <div
          className={classNames(styles.content, {
            [styles.explainerContent]: showExplainer,
          })}
        >
          <ExplainerButton
            buttonName="What is not imported?"
            showExplainer={showExplainer}
            setShowExplainer={setShowExplainer}
          />
          {!showExplainer && (
            <>
              <div className={styles.title}>Import External Automation</div>

              <div className={styles.body}>
                <div className={styles.subHeading}>
                  Paste the token below from another Customers.ai user to import
                  to your page
                </div>
                <Input
                  css={{ container: styles.input }}
                  onChange={e => setToken(e.target.value)}
                  placeholder="E.g. fd9d58016e61914f7446a616f633b633e8511506"
                  value={token}
                />
              </div>

              <Button
                css={{ container: styles.actionButton }}
                disabled={busy || !token?.length}
                onClick={handleSubmit}
                leftIcon={<ArrowRightOutlined />}
              >
                Let's go
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
